export const WRAP_UP_CHART_PROMPT_SOURCE = 'care-state-requests-tab:wrap-up-chart';

export const WRAP_UP_CHART_PROMPT = [
  'I clicked "Update and close chart". This is an explicit, definitive command to close out this chart—treat it as a direct instruction to resolve requests, not a suggestion to defer.',
  '',
  'You MUST cross-check EVERY unresolved request, one at a time, for ability to close:',
  '',
  '1. Review the evidence on the request (note, proposed actions, recent timeline).',
  "2. Append a concise plan summary to the request's note: what was done, key clinical reasoning, and any outstanding follow-up.",
  '3. Set the request status to Resolved. Do not leave it open merely because you would prefer to wait on more patient information, results, or pending actions—a fresh request is created downstream if follow-up is needed. Only keep a request open if closing it would be clinically unsafe (e.g., an unaddressed red flag), and if so state the specific blocker in one line.',
  '',
  'Never use the patient-level careNote as a substitute for a request note. If a request note cannot be updated, resolve the request without changing careNote.',
  '',
  'Do not invent labs, diagnoses, or follow-ups that are not supported by the chart.',
].join('\n');
